import Keycloak from 'keycloak-js';
const keycloak = new Keycloak({
    url: process.env.KEYCLOAK_HOSTNAME_URL,
    realm: 'fashionapps',
    clientId: 'app-frontend'
});
export const initOptions = {
    onLoad: 'login-required',
    checkLoginIframe: true,
};
export default keycloak;
